import { app_url, secret_key } from "../../config/general.json";
import { cyrb53 } from "../../config/generate_timed_key";

export interface IPurchase extends JSON {
    completed: ICompletedStep;
    step: IStepInfo;
    request: IncomingPurchaseRequest;
    images: string[];
    thumbnails: string[];
}

export interface IStepInfo {
    total: number;
    last: number;
    lastEdited: number;
}

export interface ICompletedStep {
    basic_data?: boolean;
    condition?: boolean;
    features?: boolean;
    images?: boolean;
    new_bike?: boolean;
    personal_data?: boolean;
    price?: boolean;
}

export interface IPurchaseRequestResponse {
    success?: boolean;
    errorCode?: number;
    details?: string;
}

interface IncomingPurchaseRequest {
    assesment: string | null;
    available_from: string | null;
    available_until: string | null;
    brand: string;
    buying_interest_brand: string | null;
    buying_interest_model: string | null;
    buying_interest_internal: string | null;
    chain: number | null;
    city: string;
    color:
        | "schwarz"
        | "weiß"
        | "silber"
        | "grau"
        | "grün"
        | "rot"
        | "orange"
        | "blau"
        | "gelb"
        | "gold"
        | "braun"
        | "violett"
        | "beige"
        | "tricolor";
    company: string | null;
    crash: "Umgefallen" | "Sturzschaden/Unfall" | null;
    ez: string;
    features: string | null;
    fgnr: number | null;
    first_name: string;
    front_tire: number | null;
    kd_km: number | null;
    kd_date: string | null;
    keys: number | null;
    km: number;
    mail: string;
    model: string;
    name: string;
    pickup: boolean | null;
    plz: string;
    pv: FormDataEntryValue | null;
    pe_ek?: FormDataEntryValue;
    pe_vk?: FormDataEntryValue;
    rear_tire: number | null;
    repairs: string | string[] | null;
    street: string;
    tel: string | null;
    tire_age: boolean | null;
    title: string;
    tüv: string;
    vb: string;
    ap: string | null;
    ap_team: string | null;
}

export const STATUS_CODES: { [key: string]: number } = {
    SUCCESS: 200,
    REDIRECT: 300,
    BAD_REQUEST: 400
};

export const getFetchUrl = (type: string) => {
    return app_url + type + "?key=" + generateKey();
};

export const getImageDownloadUrl = () => {
    return app_url + "image-download/";
};

const generateKey = () => {
    const now = new Date();
    now.setMinutes(now.getMinutes() % 5, 0, 0);
    const timestamp = now.getTime();
    return cyrb53(`${timestamp}${secret_key}`);
};

const getImageUrls = async (file: File): Promise<{ imageUrl: string; thumbnailUrl: string }> => {
    const body = new FormData();
    body.append("image", file);

    const response = await fetch(getFetchUrl("image"), { method: "PUT", body });

    if (response.status !== STATUS_CODES.SUCCESS) {
        throw new Error(response.statusText);
    }

    return await response.json();
};

const postRequest = async (state: IPurchase): Promise<IPurchaseRequestResponse> => {
    const body = {
        version: "1.0.0",
        ...state
    };
    const response = await fetch(getFetchUrl("request"), {
        method: "POST",
        body: JSON.stringify(body),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    });

    return await response.json();
};

export { postRequest, getImageUrls, IncomingPurchaseRequest };
